import { z } from "zod";
import { DbCreateInputOmit, DbUpdate } from "../helpers";
import { UserNotificationSettings } from "../users";
import { OmitStrict } from "../utils";
import { WorkspaceRole } from "./workspace-role";

export const WorkspaceMembership = z.object({
  id: z.string(),
  userId: z.string(),
  workspaceId: z.string(),
  workspaceRole: z.nativeEnum(WorkspaceRole),
  notificationSettings: UserNotificationSettings,
  isPrimaryOwner: z.boolean().nullish(),
});

export type WorkspaceMembership = z.infer<typeof WorkspaceMembership>;

export type CreateWorkspaceMembership = DbCreateInputOmit<WorkspaceMembership>;
export type UpdateWorkspaceMembership = OmitStrict<DbUpdate<WorkspaceMembership>, "userId" | "workspaceId">;

export const UpdateMembershipRolesInput = z.object({
  members: z.array(
    z.object({
      userId: z.string(),
      role: z.nativeEnum(WorkspaceRole),
      isPrimaryOwner: z.boolean().optional(),
    })
  ),
});

export type UpdateMembershipRolesInput = z.infer<typeof UpdateMembershipRolesInput>;
